<template>
  <div
    v-show="isOpened"
    class="modal"
    :class="{ 'modal--navigation': isModalNavigation }"
    @click="closeModal"
  >
    <div
      class="modal-container"
      @click.stop
    >
      <div class="modal-title">
        <slot name="header" />
        <button
          class="btn btn--close btn-modal-close close-action"
          @click="closeModal"
        />
      </div>
      <slot name="body" class="modal-content" />
      <slot name="footer" class="modal-footer" />
    </div>
  </div>
</template>

<script>
import { eventBus } from '@tools/event-bus';

function iOSversion() {
  if (!/iP(hone|od|ad)/.test(navigator.platform)) {
    return null;
  }

  // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
  const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
  return parseInt(v[1], 10);
}

/**
 * Init Modal component
 */
export default {
  props: {
    isOpened: { type: Boolean, default: false },
    isModalNavigation: { type: Boolean, default: false },
    onClose: { type: Function, default: null },
    clickawayAllowed: { type: Boolean, default: true },
  },
  /**
   * add no-scroll class on body when modal is opened,
   * in order to avoid scrolling issues
   */
  watch: {
    isOpened() {
      document.body.classList.toggle('no-scroll');

      // bug fix iOS 11 Safari bootstrap modal text area outside of cursor
      if (iOSversion() === 11) {
        document.body.style.position = this.isOpened ? 'fixed' : null;
      }
    },
  },
  mounted() {
    // trigger onClose method on Esc press
    document.addEventListener('keydown', (e) => {
      if (this.isOpened && e.keyCode === 27) {
        this.onClose();
      }
    });
  },
  methods: {
    /**
     * method triggered on overlay or button click.
     * trigger the close method of the parent
     */
    closeModal(event) {
      if (!this.clickawayAllowed && !event.target.classList.contains('close-action')) {
        return;
      }
      this.onClose();
    },
  },
};
</script>
